var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9351 11.1359V12.4568C36.9351 25.7575 28.6757 40.9999 13.5622 40.9999C9.10048 41.0117 4.73355 39.4276 1 36.4431C1.64841 36.5506 2.30246 36.5992 2.95676 36.5884C6.65514 36.6008 10.2495 35.0935 13.1622 32.3089C11.444 32.2779 9.77748 31.5861 8.39952 30.3318C7.02157 29.0774 6.00227 27.3243 5.48649 25.3217C5.99828 25.4542 6.52007 25.5206 7.04324 25.5198C7.7738 25.52 8.50105 25.4 9.20541 25.1632C7.34441 24.7099 5.67018 23.4806 4.46918 21.6856C3.26819 19.8906 2.61508 17.6414 2.62162 15.323V15.1909C3.76022 15.968 5.03672 16.3941 6.34054 16.4325C4.60497 15.0371 3.371 12.8847 2.89078 10.415C2.41055 7.94538 2.72031 5.3449 3.75676 3.14491C5.8219 6.24819 8.39847 8.78574 11.319 10.5926C14.2395 12.3994 17.4385 13.4351 20.7081 13.6323C20.5463 12.8826 20.4699 12.1093 20.4811 11.3341C20.4202 9.28534 20.8776 7.26346 21.791 5.54375C22.7045 3.82404 24.0295 2.49006 25.5857 1.72346C27.1419 0.956854 28.8537 0.794875 30.488 1.25958C32.1223 1.72428 33.5997 2.79308 34.7189 4.32045C36.5587 3.86684 38.3235 3.04096 39.9405 1.87692C39.3273 4.24301 38.0228 6.25059 36.2757 7.51687C37.9077 7.24211 39.4988 6.68161 41 5.85262C39.912 7.89415 38.5357 9.68309 36.9351 11.1359Z",
    fill: "white",
    stroke: "#00AFB9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.08159b6ae1c4e27ecc6104181bf00a2b.svg";
export { ForwardRef as ReactComponent };